(function(){
 const dialog=document.querySelector('#privacy-choices');if(!dialog)return;
 const names=['preferences','analytics','marketing','sale_of_data'];
 const status=dialog.querySelector('[data-privacy-status]');let opener;
 const fields=Object.fromEntries(names.map(name=>[name,dialog.querySelector(`[name=${name}]`)]));
 const gpc=navigator.globalPrivacyControl===true;
 function api(){return new Promise((resolve,reject)=>{
  if(window.Shopify?.customerPrivacy)return resolve(window.Shopify.customerPrivacy);
  if(!window.Shopify?.loadFeatures)return reject(Error('unavailable'));
  window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}],error=>error?reject(error):resolve(window.Shopify.customerPrivacy));
 })}
 function reflect(privacy){
  const choices=privacy.currentVisitorConsent();
  const allowed={preferences:privacy.preferencesProcessingAllowed(),analytics:privacy.analyticsProcessingAllowed(),marketing:privacy.marketingAllowed(),sale_of_data:privacy.saleOfDataAllowed()};
  names.forEach(name=>{fields[name].checked=choices[name]==='yes'||(choices[name]===''&&allowed[name]);});
  if(gpc){fields.sale_of_data.checked=false;fields.sale_of_data.disabled=true;dialog.querySelector('[data-privacy-gpc]').hidden=false;}
 }
 document.querySelectorAll('[data-open-privacy]').forEach(button=>button.addEventListener('click',async()=>{
  opener=button;const message=button.parentElement.querySelector('[data-privacy-open-status]');message.textContent='Loading preferences…';
  try{reflect(await api());status.textContent='';message.textContent='';dialog.showModal();dialog.querySelector('.privacy-close').focus();}
  catch{message.textContent='Preferences could not load. Please try again or contact customerservice@wipemate.com.';}
 }));
 dialog.querySelector('.privacy-close').addEventListener('click',()=>dialog.close());
 dialog.addEventListener('close',()=>opener?.focus());
 async function save(rejectAll){
  const buttons=dialog.querySelectorAll('.privacy-actions button');buttons.forEach(button=>button.disabled=true);status.textContent='Saving…';
  try{const privacy=await api();const consent=Object.fromEntries(names.map(name=>[name,rejectAll?false:fields[name].checked]));if(gpc)consent.sale_of_data=false;
   await new Promise(resolve=>privacy.setTrackingConsent(consent,resolve));reflect(privacy);status.textContent='Your cookie preferences are saved.';
  }catch{status.textContent='Preferences could not be saved. Please try again.';}
  finally{buttons.forEach(button=>button.disabled=false);}
 }
 dialog.querySelector('[data-reject-privacy]').addEventListener('click',()=>save(true));
 dialog.querySelector('[data-save-privacy]').addEventListener('click',()=>save(false));
})();

